import Link from "next/link";
import { FunctionComponent } from "react";

const Hyperlink: FunctionComponent<
  {
    href: string;
  } & JSX.IntrinsicElements["a"]
> = ({ href, children, ...props }) => {
  if (href.startsWith("http")) {
    // External link
    return (
      <a target="_blank" rel="noreferrer" href={href} {...props}>
        {children}
      </a>
    );
  } else {
    return (
      <Link href={href} passHref>
        <a {...props}>{children}</a>
      </Link>
    );
  }
};

export default Hyperlink;
